import type { UserRole } from './user-role.enum';
import type { JwtDeviceDto } from '@carvia/ros-client-types';

export interface JWTUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  isEmailConfirmed: boolean;
}

export type TokenPayload = JWTUser | JwtDeviceDto;

export function isJWTUser(payload: unknown): payload is JWTUser {
  return !!payload && typeof payload === 'object' && 'role' in payload;
}

export function isDeviceTokenPayload(payload: unknown): payload is JwtDeviceDto {
  return !!payload && typeof payload === 'object' && 'deviceRole' in payload;
}
